<div class="page-title" data-cy="training-materials-title">Training Materials</div>
<app-training-materials-list data-cy="training-materials"></app-training-materials-list>

